export function getLexicalTextLength(value: string | null | undefined) {
  if (!value) {
    return 0;
  }

  try {
    const state = JSON.parse(value);

    if (state?.root?.type !== "root" || !Array.isArray(state.root.children)) {
      return value.length;
    }

    const getText = (node: any): string => {
      if (node.type === "text") {
        return node.text ?? "";
      }

      if (!Array.isArray(node.children)) {
        return "";
      }

      return node.children
        .map(getText)
        .join(node.type === "root" || node.type === "paragraph" ? "\n" : "");
    };

    return getText(state.root).length;
  } catch {
    return value.length;
  }
}
